import * as React from "react";
import { SearchFormCore } from "./search-form-core";
import { SearchFormDesktop } from "./search-form-desktop";
import { TeaserFormMobile } from "./teaser-form-mobile";

type SearchFormProps = {
    compact?: boolean;
    valuesFromStore?: boolean;
    defaultValues?: SearchFormInputs;
};

export const SearchForm = ({ compact = false, valuesFromStore = false, defaultValues }: SearchFormProps) => {
    return (
        <SearchFormCore valuesFromStore={valuesFromStore} defaultValues={defaultValues}>
            <SearchFormDesktop className="mdmax:hidden" />
            <TeaserFormMobile className="md:hidden" compact={compact} />
        </SearchFormCore>
    );
};
